import { action } from 'satcheljs';
export default action('TOGGLE_CHARM', function toggleCharm(charm) {
    return {
        charm: charm,
    };
});
//# sourceMappingURL=toggleCharm.js.map